<template>
    <div class="container page">
        <van-nav-bar :title="$t('spxq')" class="nav-bar" fixed>
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="MallDetail">
            <img :src="goodsData.goods_pic" alt="" class="mdimg">
            <div class="mdinfo">
                <div>{{ goodsData.goods_name }}</div>
                <div>
                    <van-rate v-model="rate" void-color="#fff" readonly size="15" />
                    <span style="color: #2162a1; margin-left: 5px;">({{ rate.toFixed(2) }})</span>
                </div>
                <div>
                    <div><span>{{ $t('MAD') }} {{ goodsData.goods_price }}</span></div>
                    <div>{{ $t('yishou') }} {{ goodsData.sale_nums }}</div>
                </div>
            </div>
            <div class="mdmiaoshu">
                <div>{{ $t('spms') }}</div>
                <div v-html="goods_info"></div>
            </div>
        </div>
        <div class="buybox">
            <div>
                <van-stepper v-model="num" step="1" integer disable-input />
            </div>
            <div>{{ $t('jinetit') }}: {{ (Number(num) * Number(goodsData.goods_price || 0)).toFixed(2) }} {{ $t('MAD')
                }}
            </div>
            <div>
                <div class="yuyueBox" @click="buy">{{ $t('buytit') }}</div>
            </div>
        </div>
        <van-dialog width="80%" v-model="showKF" confirmButtonColor="#8d47ef" showCancelButton :title="$t('buysuccess')"
            :cancelButtonText="$t('cancelButtonText')" :confirmButtonText="$t('confirmButtonText')"
            :message="$t('buysuccesstxt')" @confirm="toService"></van-dialog>
    </div>
</template>

<script>
export default {
    name: "MallDetail",
    data() {
        return {
            rate: 5,
            num: 1,
            goodsData: {},
            goods_info: ``,
            showKF: false,
        }
    },
    mounted() {
        this.$httpNew({
            method: 'get',
            data: {
                id: this.$route.query.id,
            },
            url: 'get_aichao_goods_detail'
        }).then(res => {
            if (res.code == 0) {
                this.goodsData = res.data || {};
                this.goods_info = this.formatRichText(res.data.goods_info);
            } else {
                this.goodsData = {};
                this.goods_info = "";
            }
        })
    },
    methods: {
        back() {
            return window.history.back();
        },
        formatRichText(html) {
            return html.replace(/<img/g, '<img style="max-width: 100%; min-width: 100%;"');;
        },
        buy() {
            this.$httpNew({
                method: 'post',
                data: {
                    id: this.goodsData.id,
                    nums: this.num,
                },
                url: 'submit_aichao_order'
            }).then(res => {
                if (res.code == 0) {
                    this.showKF = true;
                } else {
                    this.$toast(res.info);
                }
            })
        },
        toService() {
            this.$router.push({ path: '/customerservice' });
        },
    }
}
</script>

<style lang='less' scoped>
.MallDetail {
    padding: 100px 0;

    .mdimg {
        width: 100%;
        height: 500px;
        display: block;
        object-fit: cover;
    }

    .mdinfo {
        padding: 10px;
        background: #fff;
        margin-bottom: 10px;

        >div:nth-child(1) {
            color: #565959;
            margin-bottom: 10px;
        }

        >div:nth-child(2) {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        >div:nth-child(3) {
            color: #fff;
            margin-bottom: 10px;
            background: #ff5722;
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                font-size: 46px;
                font-weight: bold;
            }
        }
    }

    .mdmiaoshu {
        background: #fff;
        padding: 10px;

        >div:nth-child(1) {
            text-align: center;
            padding: 10px 0;
            font-size: 36px;
            font-weight: bold;
        }
    }
}

.buybox {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    background: #fff;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

    .yuyueBox {
        color: #fff;
        padding: 8px 50px;
        background: linear-gradient(90deg, #323233, #000000);
        border-radius: 50px;
    }

    ::v-deep button,
    ::v-deep input {
        width: 50px;
        height: 50px;
    }

    >div:last-child {
        margin-left: auto;
    }

    >div:first-child {
        margin-right: 20px;
    }
}

::v-deep .van-dialog__header {
    padding: 20px 0 10px;
}

::v-deep .van-dialog__footer {
    padding: 20px 0 10px;
}
</style>